<template>
  <div class="sample-dropdown-main">
		<Dropdown :items="myDropdownItems" :selectedItem.sync="mySelectedItem" :selectedObject.sync="mySelectedObject"
			placeholder="Hello" :textAlign="myTextAlign" :itemKey="myItemsKey" :errorMessage.sync="em" :search.sync="test"/>
		<br>
		<div style="display: flex">
			<button style="margin: 0 5px" @click="toggleName()">Toggle Name</button>
			<button style="margin: 0 5px" @click="toggleTextAlign()">Toggle TextAlign</button>
			<button style="margin: 0 5px" @click="toggleItem()">Toggle Item</button>
			<button v-if="myItemsKey" style="margin: 0 5px" @click="toggleKey()">Toggle Key</button>
			<button style="margin: 0 5px" @click="clearSelectedItem()">Clear selectedItem</button>
		</div>
		<br>
		<div>name : {{ myName }}</div>
		<div>textAlign : {{ myTextAlign }}</div>
		<div>items : {{ JSON.stringify(myDropdownItems) }}</div>
		<div v-if="myItemsKey">itemKey : {{ myItemsKey ? myItemsKey : 'null' }}</div>
		<div>selectedItem : {{ mySelectedItem ? mySelectedItem : 'null' }}</div>
		<div>{{ test }}</div>
		<div v-if="myItemsKey">selected object : {{ mySelectedObject ? mySelectedObject : 'null' }}</div>
	</div>
</template>

<script>
/* eslint-disable */
import Dropdown from '@/components/Dropdown.vue';

export default {
  components: {
		Dropdown
	},
	props: {
		myTextAlign: { type: String, default: 'left' },
		myName: { type: String, default: 'dropdown items' },
		dropdownItemsNoKey: { type: Array, default: [
			"Item 1", 
			"Item 2", 
			"Item 3", 
			"Item 4", 
			"Item 5", 
			"Item 6", 
			"Item 7", 
			"Item 8", 
			"Item 9", 
		] },
		dropdownItemsWKey: { type: Array, default: [
			{ 'Name': 'Bob', 'Age': '32', 'Address': 'Shah Alam' },
			{ 'Name': 'John', 'Age': '25', 'Address': 'Glenmarie' },
			{ 'Name': 'Marie', 'Age': '16', 'Address': 'Klang' },
			{ 'Name': 'Claire', 'Age': '33', 'Address': 'Gombak' },
			{ 'Name': 'Andrew', 'Age': '26', 'Address': 'Batu Caves' },
			{ 'Name': 'Jane', 'Age': '26', 'Address': 'Damansara' },
			{ 'Name': 'Carly', 'Age': '44', 'Address': 'Puchong' },
			{ 'Name': 'Johnny', 'Age': '34', 'Address': 'Petaling Jaya' },
			{ 'Name': 'Taylor', 'Age': '53', 'Address': 'Subang' },
			{ 'Name': 'Bob', 'Age': '32', 'Address': 'Shah Alam' },
			{ 'Name': 'John', 'Age': '25', 'Address': 'Glenmarie' },
			{ 'Name': 'Marie', 'Age': '16', 'Address': 'Klang' },
			{ 'Name': 'Claire', 'Age': '33', 'Address': 'Gombak' },
			{ 'Name': 'Andrew', 'Age': '26', 'Address': 'Batu Caves' },
			{ 'Name': 'Jane', 'Age': '26', 'Address': 'Damansara' },
			{ 'Name': 'Carly', 'Age': '44', 'Address': 'Puchong' },
			{ 'Name': 'Johnny', 'Age': '34', 'Address': 'Petaling Jaya' },
			{ 'Name': 'Taylor', 'Age': '53', 'Address': 'Subang' },
		] },
		myDropdownItems: { type: Array, default: null },
		
		myItemsKey: { type: String, default: null },
		mySelectedItem: { type: String, default: null },
		mySelectedObject: { type: Object, default: null },

		myimages: { type: Array, default: [] },
		index: { type: Number, default: 1 },
		opacity: { type: Number, default: 1 },
		em: { type: String, default: '' },
		test: { type: String, default: '' },
	},
  methods: {
		toggleTextAlign: function() {
			switch (this.myTextAlign) {
				case 'left':
					this.myTextAlign = 'center';
					break;
				case 'center':
					this.myTextAlign = 'right';
					break;
				case 'right':
					this.myTextAlign = 'left';
					break;
			}
		},
		toggleName: function() {
			switch (this.myName) {
				case 'dropdown items':
					this.myName = 'company';
					break;
				case 'company':
					this.myName = 'customer';
					break;
				case 'customer':
					this.myName = 'dropdown items';
					break;
			}
		},
		toggleItem: function() {
			this.mySelectedItem = null;
			this.mySelectedObject = null;
			if (!this.myItemsKey) {
				this.myDropdownItems = this.dropdownItemsWKey;
				this.myItemsKey = 'Name';
			} else {
				this.myDropdownItems = this.dropdownItemsNoKey;
				this.myItemsKey = null;
			}
		},
		toggleKey: function() {
			switch (this.myItemsKey) {
				case 'Name':
					this.myItemsKey = 'Age';
					break;
				case 'Age':
					this.myItemsKey = 'Address';
					break;
				case 'Address':
					this.myItemsKey = 'Name';
					break;
			}
		},
		selectedObject: function(e) {
			this.mySelectedObject = e;
		},
		clearSelectedItem: function() {
			this.mySelectedItem = null;
			this.mySelectedObject = null;
		},
		submit: function() {
			if (!this.mySelectedObject) this.em = 'Please select an item';
		}
	},
	mounted() {
		// this.myDropdownItems = this.dropdownItemsNoKey;
		this.myDropdownItems = this.dropdownItemsWKey;
		this.myItemsKey = 'Name';

		this.mySelectedObject = this.myDropdownItems[2];

		this.myimages = [
			{ image: 'https://images.pexels.com/photos/414612/pexels-photo-414612.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500' },
			{ image: 'https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg' },
			{ image: 'https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80' }
		];

		setInterval(() => {
			this.opacity = 0;
			setTimeout(() => {
				this.index++;
				if (this.index > 2) {
					this.index = 0;
				}
				this.opacity = 1;
			}, 1000);
		}, 3000);
	}
};
</script>

<style lang="scss" scoped>
.my-dropdown {
	width: 70% !important;
	margin-bottom: 5px;
}

.sample-dropdown-main {
	flex-direction: column;
	justify-content: flex-start;
}
</style>